/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RunColorDTO } from './RunColorDTO';
import {
    RunColorDTOFromJSON,
    RunColorDTOFromJSONTyped,
    RunColorDTOToJSON,
} from './RunColorDTO';

/**
 * 
 * @export
 * @interface PutRunColorsParamsDTO
 */
export interface PutRunColorsParamsDTO {
    /**
     * 
     * @type {string}
     * @memberof PutRunColorsParamsDTO
     */
    colorListName: string;
    /**
     * Colors written with upsert semantics: they overwrite existing colors (last write wins). May be empty; colors and initialColors together must contain 1 to 1000 items, with no entity repeated within or across them
     * @type {Array<RunColorDTO>}
     * @memberof PutRunColorsParamsDTO
     */
    colors: Array<RunColorDTO>;
    /**
     * Create the list when it does not exist; otherwise a missing list is an error
     * @type {boolean}
     * @memberof PutRunColorsParamsDTO
     */
    createListIfMissing?: boolean;
    /**
     * Colors written with insert-only semantics: an entry is stored only when its entity has no color in the list yet and never overwrites an existing color. Absent or null means empty
     * @type {Array<RunColorDTO>}
     * @memberof PutRunColorsParamsDTO
     */
    initialColors?: Array<RunColorDTO>;
    /**
     * 
     * @type {string}
     * @memberof PutRunColorsParamsDTO
     */
    projectIdentifier: string;
}

/**
 * Check if a given object implements the PutRunColorsParamsDTO interface.
 */
export function instanceOfPutRunColorsParamsDTO(value: object): value is PutRunColorsParamsDTO {
    if (!('colorListName' in value) || value['colorListName'] === undefined) return false;
    if (!('colors' in value) || value['colors'] === undefined) return false;
    if (!('projectIdentifier' in value) || value['projectIdentifier'] === undefined) return false;
    return true;
}

export function PutRunColorsParamsDTOFromJSON(json: any): PutRunColorsParamsDTO {
    return PutRunColorsParamsDTOFromJSONTyped(json, false);
}

export function PutRunColorsParamsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutRunColorsParamsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'colorListName': json['colorListName'],
        'colors': ((json['colors'] as Array<any>).map(RunColorDTOFromJSON)),
        'createListIfMissing': json['createListIfMissing'] == null ? undefined : json['createListIfMissing'],
        'initialColors': json['initialColors'] == null ? undefined : ((json['initialColors'] as Array<any>).map(RunColorDTOFromJSON)),
        'projectIdentifier': json['projectIdentifier'],
    };
}

export function PutRunColorsParamsDTOToJSON(value?: PutRunColorsParamsDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'colorListName': value['colorListName'],
        'colors': ((value['colors'] as Array<any>).map(RunColorDTOToJSON)),
        'createListIfMissing': value['createListIfMissing'],
        'initialColors': value['initialColors'] == null ? undefined : ((value['initialColors'] as Array<any>).map(RunColorDTOToJSON)),
        'projectIdentifier': value['projectIdentifier'],
    };
}

